<template>
  <div class="indexAll">
    <!-- Top Section: Sidebar + Banner + UserPanel -->
    <div class="top-hero-section">
      <div class="hero-container">
        <!-- Sidebar Menu with Blur -->
        <div class="glass-sidebar">
            <TypeSelectBox :data="this.types" :typeSelect="this.typeSelect"/>
        </div>
        
        <!-- Cinematic Banner -->
        <div class="main-banner-wrapper">
          <el-carousel height="500px" arrow="hover" trigger="click" class="cinematic-carousel">
            <el-carousel-item v-for="(item, index) in banner" :key="index">
              <div class="banner-dynamic-item cur-poi" @click="clickBanner(item)">
                <el-image class="banner-img" :src="item.img" fit="cover"></el-image>
                <div class="banner-overlay"></div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <!-- User Panel with Blur -->
        <div class="glass-user-panel">
            <UserInfoPanel />
        </div>
      </div>
    </div>


    <!-- Promotional Section -->
    <div class="promo-section">
      <div class="container">
        <PromoGrid :promoData="benefitData" />
      </div>
    </div>

    <!-- Product Sections -->
    <section class="indexContent" v-loading="loading">
      <!-- Section Header -->
      <div class="premium-section-header">
        <h2 class="main-title">Guess You Like</h2>
        <span class="sub-title">PERSONALIZED SELECTION</span>
        <div class="accent-line"></div>
      </div>

      <!-- New Product List Styled Grid -->
      <div class="modern-product-grid">
        <ProductItem
          v-for="(i, index) in productNew.section"
          :key="'new-'+index"
          :obj="i"
          :type="0"/>
        <ProductItem
          v-for="(i, index) in productHot.section"
          :key="'hot-'+index"
          :obj="i"
          :type="0"/>
      </div>
    </section>
  </div>
</template>

<script>
import ProductItem from './components/indexItem'
import CDItem from './components/countdownItem'
import TypeSelectBox from './components/typeSelectBox.vue'
import UserInfoPanel from './components/UserInfoPanel.vue'
import PromoGrid from './components/PromoGrid.vue'
import {
  getIndexPageList,
  getCanvasData,
  getCategory,
  getNotices
} from '@/api/indexpage.js'

export default {
  components: {
    ProductItem,
    CDItem,
    TypeSelectBox,
    UserInfoPanel,
    PromoGrid
  },
  data () {
    return {
      productNew: {
        'header': { 'title': 'New Arrivals', 'bcText': 'THE NEW START' },
        'section': []
      },
      productHot: {
        'header': { 'title': 'Best Sellers', 'bcText': 'POPULAR STYLE' },
        'section': []
      },
      banner: [],
      types: [],
      typeSelect: '',
      benefitData: [],
      loading: false
    }
  },
  created () {
    this.getIndexData()
    this.getCanvas()
    this.getCateList()
  },
  methods: {
    async getCanvas () {
      const res = await getCanvasData({ terminal: '4' })
      if (res.status === 200 && res.data.content && res.data.content.json) {
        const originalData = JSON.parse(res.data.content.json)
        const bannerData = originalData.find(item => item.type === 'PcBanner')
        if (bannerData) this.banner = bannerData.value
      }
    },
    async getCateList () {
        const response = await getCategory()
        if (response.status === 200) {
            const res = response.data.content
            this.types = res.map(item => ({
                value: `${item.id}`,
                label: `${item.cateName}`,
                children: (item.children || []).map(i => ({ value: i.id, label: i.cateName, pic: i.pic }))
            }))
            if (this.types.length > 0) this.typeSelect = this.types[0].value
        }
    },
    getIndexData () {
      this.loading = true
      getIndexPageList().then(res => {
          if (res.status === 200) {
            this.productNew.section = res.data.firstList.slice(0, 4)
            this.productHot.section = res.data.likeInfo.slice(0, 4)
            this.benefitData = res.data.benefit || []
          }
      }).finally(() => this.loading = false)
    },
    clickBanner (item) {
      if (item.url) {
        if (item.url.startsWith('http')) {
          window.open(item.url, '_blank')
        } else {
          this.$router.push(item.url)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.indexAll {
  width: 100%;
  background-color: $gray-50;
  min-height: 100vh;
  padding-bottom: 80px;

  .hero-container {
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    gap: 24px;
    padding: 24px 0;
  }

  .top-hero-section {
    background: $white;
    margin-bottom: 40px;
    border-bottom: 1px solid $gray-100;
  }

  .glass-sidebar {
    flex: 0 0 260px;
    height: 500px;
    z-index: 10;
  }

  .glass-user-panel {
    flex: 0 0 280px;
    height: 500px;
    display: flex;
  }

  .main-banner-wrapper {
    flex: 1;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: $shadow-lg;
    
    .cinematic-carousel {
      .banner-dynamic-item {
        position: relative;
        height: 100%;
        overflow: hidden;
        cursor: pointer;
        
        .banner-img {
          width: 100%;
          height: 100%;
          transition: transform 8s ease;
        }

        .banner-overlay {
          position: absolute;
          bottom: 0; left: 0; right: 0;
          height: 40%;
          background: linear-gradient(to top, rgba(0,0,0,0.4), transparent);
        }
      }
      
      .el-carousel__item--card.is-active .banner-img {
          transform: scale(1.1);
      }
    }
  }

  .promo-section {
    margin-bottom: 60px;
    .container { max-width: 1200px; margin: 0 auto; }
  }

  .indexContent {
    max-width: 1200px;
    margin: 0 auto;

    .premium-section-header {
      text-align: center;
      margin-bottom: 48px;
      position: relative;

      .main-title {
        font-family: 'Inter', serif;
        font-size: 32px;
        font-weight: 900;
        color: $gray-900;
        letter-spacing: -0.5px;
        margin-bottom: 8px;
        text-transform: uppercase;
      }
      
      .sub-title {
        font-size: 13px;
        color: $gray-400;
        font-weight: 800;
        letter-spacing: 3px;
      }

      .accent-line {
        width: 40px;
        height: 3px;
        background: $primary-color;
        margin: 16px auto 0;
        border-radius: 2px;
      }
    }

    .modern-product-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 24px;
    }
  }
}

/* Indicators Styling */
::v-deep .el-carousel__indicators--horizontal {
  bottom: 24px;
  background: rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 20px;
  backdrop-filter: blur(4px);
}
::v-deep .el-carousel__button {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  opacity: 0.6;
}
::v-deep .is-active .el-carousel__button {
  width: 20px;
  border-radius: 3px;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/Index.vue